import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {PriceBookRuleContainerModel} from '../../../../../../models/aggregates/erp/price-book-rule';
import {Core2Config} from '../../shared';
import {
  LabelCriteriaModelQuery,
  LabelQueryCriteriaClass,
  PriceBookCriteriaModelQuery, PriceBookRuleCriteriaModelQuery,
  PriceBookRuleQueryCriteriaClass
} from "../../../criteria";
import {Observable} from "rxjs";
import {LabelContainerModel} from "../../../../../../models/aggregates/erp/label";


@Injectable({
  providedIn: 'root'
})
export class PriceBookRuleService extends BaseApiTemplateService<PriceBookRuleContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'price-book-rule';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'price-book-rule';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'price-book-rule';
    this.httpClient = http;
  }
  getByCriteriaObservable(
    visa: ApiVisa, criteria?: PriceBookRuleQueryCriteriaClass
  ): Observable<ApiResponseModel<PriceBookRuleContainerModel>> {
    const buildDocCriteria = new PriceBookRuleCriteriaModelQuery(criteria);
    const apiUrl = visa.api_domain_url + this.endpoint_path;
    const UrlByCriteria = apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<PriceBookRuleContainerModel>>
    (UrlByCriteria, this.getHttpHeader(visa));
  }
}


